<template>
  <section>
    <v-layout row wrap>
      <v-flex xs4>
        <v-select
          :items="tiposDoc"
          v-model="persona.tipo_documento"
          label="Tipo de documento"
          item-text="text"
          item-value="value"
          :rules="$validate(['required'])"
          required
          class="required"
          :disabled="(!cambiarDatos && !watchOnly) || persona.contrastado"
          :readonly="watchOnly"
          ></v-select>
      </v-flex>
      <v-flex xs4>
        <v-text-field
          label="Número de documento"
          v-model="persona.nro_documento"
          maxlength="20"
          @keydown.native="$filter.numeric($event)"
          :rules="$validate(['required'])"
          required
          class="required"
          :disabled="(!cambiarDatos && !watchOnly) || persona.contrastado"
          :readonly="watchOnly"
          ></v-text-field>
      </v-flex>
      <v-flex xs4>
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          max-width="290px"
          min-width="290px"
          >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="fecha_nacimiento"
              label="Fecha Nacimiento"
              maxlength="10"
              prepend-icon="event"
              class="required"
              :rules="$validate(['required'])"
              v-on="on"
              :disabled="(!cambiarDatos && !watchOnly) || persona.contrastado"
              :readonly="watchOnly"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="persona.fecha_nacimiento"
            no-title
            scrollable
            locale="es-es"
            @input="menu = false"
            v-if="!watchOnly"
          />
        </v-menu>
      </v-flex>
      
    </v-layout>
    <v-layout row wrap>
      <v-flex xs4>
        <v-text-field
          label="Nombre(s)"
          v-model="persona.nombres"
          maxlength="100"
          :rules="$validate(['required'])"
          class="required"
          required
          :disabled="(!cambiarDatos && !watchOnly) || (persona.contrastado && persona.tipo_documento === 'CI')"
          :readonly="watchOnly"
          ></v-text-field>
      </v-flex>

      <v-flex xs4>
        <v-text-field
          label="Primer apellido"
          v-model="persona.primer_apellido"
          maxlength="100"
          required
          :disabled="(!cambiarDatos && !watchOnly) || (watchOnly && !!persona.primer_apellido) || (persona.contrastado && persona.tipo_documento === 'CI')"
          :readonly="watchOnly"
          ></v-text-field>
      </v-flex>

      <v-flex xs4>
        <v-text-field
          label="Segundo apellido"
          v-model="persona.segundo_apellido"
          maxlength="100"
          :disabled="(!cambiarDatos && !watchOnly) || (watchOnly && !persona.segundo_apellido) || (persona.contrastado && persona.tipo_documento === 'CI')"
          :readonly="watchOnly"
          ></v-text-field>
      </v-flex>

      <v-flex xs4>
        <v-autocomplete
          :items="nacionalidades"
          v-model="persona.nacionalidad"
          label="Nacionalidad"
          item-text="text"
          item-value="value"
          :rules="$validate(['required'])"
          :disabled="(!cambiarDatos && !watchOnly) || (persona.contrastado && persona.tipo_documento === 'CI')"
          :readonly="watchOnly"
          required
          class="required"
          ></v-autocomplete>
      </v-flex>

      <v-flex xs4>
        <v-radio-group
          v-model="persona.genero"
          row
          :rules="$validate(['required'])"
          :disabled="!cambiarDatos && !watchOnly"
          :readonly="watchOnly"
          required
          class="required"
        >
          <v-radio
            label="Mujer"
            value="F"
          ></v-radio>
          <v-radio
            label="Hombre"
            value="M"
          ></v-radio>
        </v-radio-group>
      </v-flex>

      <v-flex xs4>
        <v-btn
          v-if="(!cambiarDatos && !watchOnly) || persona.contrastado"
          @click="cambioDatos()"><v-icon>compare_arrows</v-icon> Cambiar</v-btn>
        <v-btn
          color="info"
          v-if="cambiarDatos && !watchOnly && !persona.contrastado"
          :loading="loading"
          :disabled="loading"
          @click="buscarPersona()"><v-icon>search</v-icon> Verificar</v-btn>
      </v-flex>

      
      <v-flex xs4>
        <v-text-field
          label="Móvil"
          prepend-icon="smartphone"
          v-model="persona.movil"
          maxlength="30"
          :disabled="(!cambiarDatos && !watchOnly) || (watchOnly && !persona.movil)"
          :readonly="watchOnly"
          @keydown.native="$filter.numeric($event)"
          ></v-text-field>
      </v-flex>

      <v-flex xs4>
        <v-text-field
          label="Teléfono"
          prepend-icon="phone"
          v-model="persona.telefono"
          maxlength="30"
          :disabled="(!cambiarDatos && !watchOnly) || (watchOnly && !persona.telefono)"
          :readonly="watchOnly"
          @keydown.native="$filter.numeric($event)"
          ></v-text-field>
      </v-flex>

    </v-layout>
    <h4>
      Otros datos
      <v-tooltip bottom>
        <v-btn icon slot="activator" @click.native.stop="agregarOtroDato()" color="primary" small v-if="cambiarDatos && !watchOnly">
          <v-icon>add</v-icon>
        </v-btn>
        <span>{{ $t('persona.agregar_dato') }}</span>
      </v-tooltip>
    </h4>
    <v-layout row wrap v-for="(dato, idx) in persona.otros_datos" v-bind:key="idx">
      <v-flex xs4>
        <v-select
          :items="opcionesDatos"
          v-model="persona.otros_datos[idx].key"
          label="Seleccione un tipo de dato"
          item-text="text"
          item-value="value"
          required
          class="required"
          :disabled="!cambiarDatos && !watchOnly"
          :readonly="watchOnly"
          @change="actualizarPersona()"
        ></v-select>
      </v-flex>
      <v-flex xs7>
        <v-text-field
          label="Dato"
          v-model="persona.otros_datos[idx].value"
          maxlength="200"
          class="required"
          required
          :disabled="!cambiarDatos && !watchOnly"
          :readonly="watchOnly"
          @input="actualizarPersona()"
        ></v-text-field>
      </v-flex>
      <v-flex xs1>
        <v-tooltip bottom>
          <v-btn icon slot="activator" dark @click.native="removerDato(idx)" small v-if="cambiarDatos && !watchOnly">
            <v-icon color="red">delete</v-icon>
          </v-btn>
          <span>{{ $t('persona.remover_dato') }}</span>
        </v-tooltip>
      </v-flex>
    </v-layout>
  </section>
</template>

<script>
import validate from '@/common/mixins/validate';
import paises from '@/common/mixins/paises';

export default {
  mixins: [ validate, paises ],
  props: ['id', 'change', 'db', 'opcionesDatos', 'watchOnly'],
  created () {
    let items = this.getPaises();
    let paises = [];
    let nacionalidades = [];
    items.map(item => {
      paises.push({ value: item.pais, text: item.pais });
      nacionalidades.push({ value: item.nacionalidad, text: item.nacionalidad });
    });
    this.paises = paises;
    this.nacionalidades = nacionalidades;
  },
  mounted () {
    this.$nextTick(() => {
      this.recuperarpersona();
    });
  },
  data () {
    return {
      fecha_nacimiento: null,
      paises: [],
      nacionalidades: [],
      valid: false,
      persona: {
        id: 0,
        otros_datos: [],
        nombres: '',
        primer_apellido: '',
        segundo_apellido: '',
        contrastado: false
      },
      cambiarDatos: false,
      tiposDoc: [
        { value: 'CI', text: 'CÉDULA DE IDENTIDAD' },
        { value: 'PASAPORTE', text: 'PASAPORTE' }
      ],
      loading: false,
      menu: false,
      refrescar: true
    };
  },
  watch: {
    'persona.fecha_nacimiento' (value) {
      this.fecha_nacimiento = this.formato(value);
      this.$emit('recuperar', this.persona);
    },
    'persona.tipo_documento' (value) {
      if (value === 'CI' && this.cambiarDatos) {
        this.persona.nombres = '';
        this.persona.primer_apellido = '';
        this.persona.segundo_apellido = '';
      }
      this.$emit('recuperar', this.persona);
    },
    'persona.nro_documento' () {
      this.$emit('recuperar', this.persona);
    },
    'persona.nombres' () {
      // this.persona.nombres = this.persona.nombres.toUpperCase();
      this.$emit('recuperar', this.persona);
    },
    'persona.primer_apellido' () {
      // this.persona.primer_apellido = this.persona.primer_apellido.toUpperCase();
      this.$emit('recuperar', this.persona);
    },
    'persona.segundo_apellido' () {
      // this.persona.segundo_apellido = this.persona.segundo_apellido.toUpperCase();
      this.$emit('recuperar', this.persona);
    },
    'persona.genero' () {
      this.$emit('recuperar', this.persona);
    },
    'persona.otros_datos' () {
      this.$emit('recuperar', this.persona);
    },
    fecha_nacimiento (value) {
      if (value) {
        this.fecha_nacimiento = this.fecha_nacimiento.replace('-', '/');
        let fecha = value.split('/');
        if (fecha.length === 3 && fecha[2].length === 4) {
          this.persona.fecha_nacimiento = `${fecha[2]}-${fecha[1].length > 1 ? fecha[1] : `0${fecha[1]}`}-${fecha[0].length > 1 ? fecha[0] : `0${fecha[0]}`}`;
        }
      }
      this.$emit('recuperar', this.persona);
    }
  },
  beforeCreate () {

  },
  computed: {
    formatedDate () {
      if (this.persona.fecha_nacimiento) {
        let date = this.persona.fecha_nacimiento;
        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
      } else {
        return '';
      }
    }
  },
  methods: {
    formato (valor) {
      if (valor) {
        let date = valor;
        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
      } else {
        return '';
      }
    },
    buscarPersona () {
      this.$loading.show('Buscando persona');
      this.loading = true;
      let generoSeleccionado = this.persona.genero;
      let otrosDatos = this.persona.otros_datos;
      let datosPersona = {
        nro_documento: this.persona.nro_documento,
        fecha_nacimiento: this.fecha_nacimiento,
        primer_apellido: this.persona.primer_apellido.toUpperCase(),
        nombres: this.persona.nombres.toUpperCase()
      };
      if (this.persona.segundo_apellido && this.persona.segundo_apellido.length > 0) {
        datosPersona.segundo_apellido = this.persona.segundo_apellido.toUpperCase();
      } else {
        datosPersona.segundo_apellido = '--';
      }

      let url = `system/personas/contrastar`;
      this.$service.patch(url, datosPersona)
      .then(response => {
        this.loading = false;
        if (response) {
          if (response.estado === 'VERIFICADO_SEGIP' && response.data === '') {
            this.persona.nacionalidad = 'BOLIVIANA';
            this.persona.nombres = datosPersona.nombres.toUpperCase();
            this.persona.primer_apellido = datosPersona.primer_apellido.toUpperCase();
            if (datosPersona.segundo_apellido === '--') {
              this.persona.segundo_apellido = '';
            } else {
              this.persona.segundo_apellido = datosPersona.segundo_apellido.toUpperCase();
            }
            this.persona.genero = generoSeleccionado;
            this.persona.otros_datos = response.otros_datos && response.otros_datos.length > 0 ? response.otros_datos : otrosDatos;
            this.persona.contrastado = true;
            this.$message.success(`Los datos son válidos.`, null, { timeout: 7000 });
            this.$emit('recuperar', this.persona);
          } else if (this.persona.tipo_documento !== 'CI') {
            this.$message.warning(`No se encontraron los datos <br /> <strong>Ingrese los datos manualmente</strong>`, null, { timeout: 12000 });
            this.persona.primer_apellido = '';
            this.persona.segundo_apellido = '';
            this.persona.nombres = '';
            this.persona.contrastado = true;
            this.$emit('recuperar', this.persona);
          } else {
            this.$message.warning(`Los datos parecen incorrectos, revíselos.<br /> <strong>`, response, `</strong>`, null, { timeout: 12000 });
          }
        } else {
          this.$message.error(`Ocurrió un problema. No se encontraron los datos <br /> <strong>Comuníquese con su administrador.</strong>`, null, { timeout: 10000 });
        }
      });
    },
    cambioDatos () {
      this.cambiarDatos = true;
      this.persona.contrastado = false;
    },
    recuperarpersona () {
      if (this.id > 0) {
        this.loading = true;
        this.$loading.show('Buscando persona');
        this.$service.get(`system/personas/${this.id}`, {})
        .then(response => {
          if (response) {
            this.persona = response;
            this.fecha_nacimiento = this.formato(this.persona.fecha_nacimiento);
            this.$emit('recuperar', this.persona);
            this.loading = false;
          }
        });
      } else {
        this.cambiarDatos = true;
        this.persona = {
          nacionalidad: 'BOLIVIANA',
          otros_datos: []
        };
      }
    },
    agregarOtroDato () {
      if (this.persona) {
        if (!this.persona.otros_datos) {
          this.persona.otros_datos = [];
        }
        this.persona.otros_datos.push({
          key: '',
          value: ''
        });
      }
    },
    removerDato (item) {
      if (this.persona && this.persona.otros_datos && item >= 0) {
        this.persona.otros_datos.splice(item, 1);
      }
    },
    actualizarPersona () {
      this.$emit('recuperar', this.persona);
    }
  },
  components: {}
};
</script>



// WEBPACK FOOTER //
// src/components/admin/persona/PersonaDatosContrast.vue